/* tslint:disable */
import {
  KanvasUser,
  Address,
  Tag,
  PlayerGroup,
  PlayerSerial
} from '../index';

declare var Object: any;
export interface PlayerInterface {
  "id": string;
  "PlayerType": string;
  "Status": string;
  "HardwareType": string;
  "Description"?: string;
  "Description2"?: string;
  "Comment"?: string;
  "AutoResize": boolean;
  "ForceWidth"?: number;
  "ForceHeight"?: number;
  "lastHeartbeat"?: Date;
  "lastWanIp"?: string;
  "lastLanIp"?: string;
  "lastMacAddress"?: string;
  "urlThumb1"?: string;
  "urlThumb2"?: string;
  "urlThumb3"?: string;
  "LastCheckInGeoIp"?: any;
  "AllowToUpdate": boolean;
  "Activated": boolean;
  "ActivatedDate"?: Date;
  "LocationName": string;
  "Address1": string;
  "Address2"?: string;
  "City": string;
  "State": string;
  "Zip": string;
  "LastScheduleUpdate"?: Date;
  "SoftwareVersion"?: string;
  "LastProgramUpdate"?: Date;
  "ProgramUpdateInterval": number;
  "ScheduleUpdateInterval": number;
  "isDisplayVertical": boolean;
  "osControlledVertical": boolean;
  "displayRows": number;
  "displayCols": number;
  "displayResolutionWidth": number;
  "displayResolutionHeight": number;
  "phone"?: string;
  "useRealtime": boolean;
  "realtimeThrottleTime"?: number;
  "allowRealtimeForWebPlayer": boolean;
  "allowOverrideSettings": boolean;
  "heartbeatInterval": number;
  "screenshotPerHeartbeat": number;
  "programUpdateWindowEnabled": boolean;
  "scheduleUpdateWindowEnabled": boolean;
  "programUpdateWindowStart"?: Date;
  "programUpdateWindowEnd"?: Date;
  "scheduleUpdateWindowStart"?: Date;
  "scheduleUpdateWindowEnd"?: Date;
  "downloadThrottleSpeedEnabled": boolean;
  "downloadThrottleSpeed"?: number;
  "dailyRestartEnabled": boolean;
  "dailyRestartTime"?: Date;
  "dailyRestartMode"?: string;
  "lastHeartbeatData"?: any;
  "localTimeZone"?: string;
  "syncTimeToServer"?: boolean;
  "useDST"?: boolean;
  "timeSyncInterval": number;
  "disableWindowsUpdates"?: boolean;
  "restartOnSystemExhaustionEvent"?: boolean;
  "restartOnVideoCardCrash"?: boolean;
  "disableWindowsDefender"?: boolean;
  "disableUnusedWindowsServices"?: boolean;
  "enableGPURendering"?: boolean;
  "realm"?: string;
  "username"?: string;
  "email": string;
  "emailVerified"?: boolean;
  "kanvasUserId"?: string;
  "parentContributorId"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "locationAddressId"?: string;
  "overrideGroupId"?: string;
  "singlePlayerGroupId"?: string;
  "playerSerialId"?: string;
  "password"?: string;
  accessTokens?: any[];
  kanvasUser?: KanvasUser;
  parentContributor?: KanvasUser;
  locationAddress?: Address;
  tags?: Tag[];
  playerGroups?: PlayerGroup[];
  singlePlayerGroup?: PlayerGroup;
  overridePlayerGroup?: PlayerGroup;
  playerSerial?: PlayerSerial;
}

export class Player implements PlayerInterface {
  "id": string;
  "PlayerType": string;
  "Status": string;
  "HardwareType": string;
  "Description": string;
  "Description2": string;
  "Comment": string;
  "AutoResize": boolean;
  "ForceWidth": number;
  "ForceHeight": number;
  "lastHeartbeat": Date;
  "lastWanIp": string;
  "lastLanIp": string;
  "lastMacAddress": string;
  "urlThumb1": string;
  "urlThumb2": string;
  "urlThumb3": string;
  "LastCheckInGeoIp": any;
  "AllowToUpdate": boolean;
  "Activated": boolean;
  "ActivatedDate": Date;
  "LocationName": string;
  "Address1": string;
  "Address2": string;
  "City": string;
  "State": string;
  "Zip": string;
  "LastScheduleUpdate": Date;
  "SoftwareVersion": string;
  "LastProgramUpdate": Date;
  "ProgramUpdateInterval": number;
  "ScheduleUpdateInterval": number;
  "isDisplayVertical": boolean;
  "osControlledVertical": boolean;
  "displayRows": number;
  "displayCols": number;
  "displayResolutionWidth": number;
  "displayResolutionHeight": number;
  "phone": string;
  "useRealtime": boolean;
  "realtimeThrottleTime": number;
  "allowRealtimeForWebPlayer": boolean;
  "allowOverrideSettings": boolean;
  "heartbeatInterval": number;
  "screenshotPerHeartbeat": number;
  "programUpdateWindowEnabled": boolean;
  "scheduleUpdateWindowEnabled": boolean;
  "programUpdateWindowStart": Date;
  "programUpdateWindowEnd": Date;
  "scheduleUpdateWindowStart": Date;
  "scheduleUpdateWindowEnd": Date;
  "downloadThrottleSpeedEnabled": boolean;
  "downloadThrottleSpeed": number;
  "dailyRestartEnabled": boolean;
  "dailyRestartTime": Date;
  "dailyRestartMode": string;
  "lastHeartbeatData": any;
  "localTimeZone": string;
  "syncTimeToServer": boolean;
  "useDST": boolean;
  "timeSyncInterval": number;
  "disableWindowsUpdates": boolean;
  "restartOnSystemExhaustionEvent": boolean;
  "restartOnVideoCardCrash": boolean;
  "disableWindowsDefender": boolean;
  "disableUnusedWindowsServices": boolean;
  "enableGPURendering": boolean;
  "realm": string;
  "username": string;
  "email": string;
  "emailVerified": boolean;
  "kanvasUserId": string;
  "parentContributorId": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  "locationAddressId": string;
  "overrideGroupId": string;
  "singlePlayerGroupId": string;
  "playerSerialId": string;
  "password": string;
  accessTokens: any[];
  kanvasUser: KanvasUser;
  parentContributor: KanvasUser;
  locationAddress: Address;
  tags: Tag[];
  playerGroups: PlayerGroup[];
  singlePlayerGroup: PlayerGroup;
  overridePlayerGroup: PlayerGroup;
  playerSerial: PlayerSerial;
  constructor(data?: PlayerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Player`.
   */
  public static getModelName() {
    return "Player";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Player for dynamic purposes.
  **/
  public static factory(data: PlayerInterface): Player{
    return new Player(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Player',
      plural: 'Players',
      path: 'Players',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "PlayerType": {
          name: 'PlayerType',
          type: 'string'
        },
        "Status": {
          name: 'Status',
          type: 'string'
        },
        "HardwareType": {
          name: 'HardwareType',
          type: 'string'
        },
        "Description": {
          name: 'Description',
          type: 'string'
        },
        "Description2": {
          name: 'Description2',
          type: 'string'
        },
        "Comment": {
          name: 'Comment',
          type: 'string'
        },
        "AutoResize": {
          name: 'AutoResize',
          type: 'boolean'
        },
        "ForceWidth": {
          name: 'ForceWidth',
          type: 'number',
          default: 0
        },
        "ForceHeight": {
          name: 'ForceHeight',
          type: 'number',
          default: 0
        },
        "lastHeartbeat": {
          name: 'lastHeartbeat',
          type: 'Date',
          default: new Date(0)
        },
        "lastWanIp": {
          name: 'lastWanIp',
          type: 'string'
        },
        "lastLanIp": {
          name: 'lastLanIp',
          type: 'string'
        },
        "lastMacAddress": {
          name: 'lastMacAddress',
          type: 'string'
        },
        "urlThumb1": {
          name: 'urlThumb1',
          type: 'string'
        },
        "urlThumb2": {
          name: 'urlThumb2',
          type: 'string'
        },
        "urlThumb3": {
          name: 'urlThumb3',
          type: 'string'
        },
        "LastCheckInGeoIp": {
          name: 'LastCheckInGeoIp',
          type: 'any',
          default: <any>null
        },
        "AllowToUpdate": {
          name: 'AllowToUpdate',
          type: 'boolean'
        },
        "Activated": {
          name: 'Activated',
          type: 'boolean'
        },
        "ActivatedDate": {
          name: 'ActivatedDate',
          type: 'Date'
        },
        "LocationName": {
          name: 'LocationName',
          type: 'string'
        },
        "Address1": {
          name: 'Address1',
          type: 'string'
        },
        "Address2": {
          name: 'Address2',
          type: 'string'
        },
        "City": {
          name: 'City',
          type: 'string'
        },
        "State": {
          name: 'State',
          type: 'string'
        },
        "Zip": {
          name: 'Zip',
          type: 'string'
        },
        "LastScheduleUpdate": {
          name: 'LastScheduleUpdate',
          type: 'Date'
        },
        "SoftwareVersion": {
          name: 'SoftwareVersion',
          type: 'string'
        },
        "LastProgramUpdate": {
          name: 'LastProgramUpdate',
          type: 'Date'
        },
        "ProgramUpdateInterval": {
          name: 'ProgramUpdateInterval',
          type: 'number'
        },
        "ScheduleUpdateInterval": {
          name: 'ScheduleUpdateInterval',
          type: 'number'
        },
        "isDisplayVertical": {
          name: 'isDisplayVertical',
          type: 'boolean'
        },
        "osControlledVertical": {
          name: 'osControlledVertical',
          type: 'boolean'
        },
        "displayRows": {
          name: 'displayRows',
          type: 'number'
        },
        "displayCols": {
          name: 'displayCols',
          type: 'number'
        },
        "displayResolutionWidth": {
          name: 'displayResolutionWidth',
          type: 'number'
        },
        "displayResolutionHeight": {
          name: 'displayResolutionHeight',
          type: 'number'
        },
        "phone": {
          name: 'phone',
          type: 'string'
        },
        "useRealtime": {
          name: 'useRealtime',
          type: 'boolean'
        },
        "realtimeThrottleTime": {
          name: 'realtimeThrottleTime',
          type: 'number'
        },
        "allowRealtimeForWebPlayer": {
          name: 'allowRealtimeForWebPlayer',
          type: 'boolean'
        },
        "allowOverrideSettings": {
          name: 'allowOverrideSettings',
          type: 'boolean'
        },
        "heartbeatInterval": {
          name: 'heartbeatInterval',
          type: 'number'
        },
        "screenshotPerHeartbeat": {
          name: 'screenshotPerHeartbeat',
          type: 'number'
        },
        "programUpdateWindowEnabled": {
          name: 'programUpdateWindowEnabled',
          type: 'boolean'
        },
        "scheduleUpdateWindowEnabled": {
          name: 'scheduleUpdateWindowEnabled',
          type: 'boolean'
        },
        "programUpdateWindowStart": {
          name: 'programUpdateWindowStart',
          type: 'Date'
        },
        "programUpdateWindowEnd": {
          name: 'programUpdateWindowEnd',
          type: 'Date'
        },
        "scheduleUpdateWindowStart": {
          name: 'scheduleUpdateWindowStart',
          type: 'Date'
        },
        "scheduleUpdateWindowEnd": {
          name: 'scheduleUpdateWindowEnd',
          type: 'Date'
        },
        "downloadThrottleSpeedEnabled": {
          name: 'downloadThrottleSpeedEnabled',
          type: 'boolean'
        },
        "downloadThrottleSpeed": {
          name: 'downloadThrottleSpeed',
          type: 'number'
        },
        "dailyRestartEnabled": {
          name: 'dailyRestartEnabled',
          type: 'boolean'
        },
        "dailyRestartTime": {
          name: 'dailyRestartTime',
          type: 'Date'
        },
        "dailyRestartMode": {
          name: 'dailyRestartMode',
          type: 'string'
        },
        "lastHeartbeatData": {
          name: 'lastHeartbeatData',
          type: 'any'
        },
        "localTimeZone": {
          name: 'localTimeZone',
          type: 'string'
        },
        "syncTimeToServer": {
          name: 'syncTimeToServer',
          type: 'boolean'
        },
        "useDST": {
          name: 'useDST',
          type: 'boolean'
        },
        "timeSyncInterval": {
          name: 'timeSyncInterval',
          type: 'number'
        },
        "disableWindowsUpdates": {
          name: 'disableWindowsUpdates',
          type: 'boolean'
        },
        "restartOnSystemExhaustionEvent": {
          name: 'restartOnSystemExhaustionEvent',
          type: 'boolean'
        },
        "restartOnVideoCardCrash": {
          name: 'restartOnVideoCardCrash',
          type: 'boolean'
        },
        "disableWindowsDefender": {
          name: 'disableWindowsDefender',
          type: 'boolean'
        },
        "disableUnusedWindowsServices": {
          name: 'disableUnusedWindowsServices',
          type: 'boolean'
        },
        "enableGPURendering": {
          name: 'enableGPURendering',
          type: 'boolean'
        },
        "realm": {
          name: 'realm',
          type: 'string'
        },
        "username": {
          name: 'username',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "emailVerified": {
          name: 'emailVerified',
          type: 'boolean'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "parentContributorId": {
          name: 'parentContributorId',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "locationAddressId": {
          name: 'locationAddressId',
          type: 'string'
        },
        "overrideGroupId": {
          name: 'overrideGroupId',
          type: 'string'
        },
        "singlePlayerGroupId": {
          name: 'singlePlayerGroupId',
          type: 'string'
        },
        "playerSerialId": {
          name: 'playerSerialId',
          type: 'string'
        },
        "password": {
          name: 'password',
          type: 'string'
        },
      },
      relations: {
        accessTokens: {
          name: 'accessTokens',
          type: 'any[]',
          model: '',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'userId'
        },
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        parentContributor: {
          name: 'parentContributor',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'parentContributorId',
          keyTo: 'id'
        },
        locationAddress: {
          name: 'locationAddress',
          type: 'Address',
          model: 'Address',
          relationType: 'belongsTo',
                  keyFrom: 'locationAddressId',
          keyTo: 'id'
        },
        tags: {
          name: 'tags',
          type: 'Tag[]',
          model: 'Tag',
          relationType: 'hasMany',
          modelThrough: 'TagPlayer',
          keyThrough: 'tagId',
          keyFrom: 'id',
          keyTo: 'playerId'
        },
        playerGroups: {
          name: 'playerGroups',
          type: 'PlayerGroup[]',
          model: 'PlayerGroup',
          relationType: 'hasMany',
          modelThrough: 'PlayerGroupPlayer',
          keyThrough: 'playerGroupId',
          keyFrom: 'id',
          keyTo: 'playerId'
        },
        singlePlayerGroup: {
          name: 'singlePlayerGroup',
          type: 'PlayerGroup',
          model: 'PlayerGroup',
          relationType: 'belongsTo',
                  keyFrom: 'singlePlayerGroupId',
          keyTo: 'id'
        },
        overridePlayerGroup: {
          name: 'overridePlayerGroup',
          type: 'PlayerGroup',
          model: 'PlayerGroup',
          relationType: 'belongsTo',
                  keyFrom: 'overrideGroupId',
          keyTo: 'id'
        },
        playerSerial: {
          name: 'playerSerial',
          type: 'PlayerSerial',
          model: 'PlayerSerial',
          relationType: 'belongsTo',
                  keyFrom: 'playerSerialId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Player.ts